import React from 'react';
import MuiCard from '@mui/material/Card';
import { useTheme } from '@mui/material/styles';

/**
 * Custom Card component with default shadow and border radius.
 * @param {object} props - The props for Card.
 * @param {object} [props.sx] - The system style overrides for the Card.
 * @param {React.ReactNode} [props.children] - Card content.
 */
const Card = ({ sx = {}, ...props }) => {
  const theme = useTheme();
  return (
    <MuiCard
      {...props}
      sx={{
        boxShadow: '0 2px 8px 0 rgba(34,41,47,0.08)',
        background: theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.palette.background.paper,
        borderRadius: 2,
        ...sx,
      }}
    />
  );
};

export default Card;
